import { mergeDeep } from '@/helpers/utils'
import { ISchema, PaywallComponentProps } from '../../@types'

import beforePng from '@/assets/paywall/current-goal/microdrama-tai-chi-walking-f/before.png'
import afterPng from '@/assets/paywall/current-goal/microdrama-tai-chi-walking-f/after.png'

export default (schema: ISchema): ISchema => {
	const order = [...schema.order]
	const anchor = order.indexOf('PaywallCurrentGoal')

	// splice(-1, …) would silently move the block to the end of the paywall
	if (anchor === -1) return schema

	order.splice(
		anchor,
		1,
		[
			'PaywallTitle',
			(): PaywallComponentProps.Title => ({
				title: `YOUR BEST YEARS <span class="text-success">START NOW</span>`,
				textAlignment: 'center',
				customStyles: {
					fontSize: 'var(--size-32)',
					lineHeight: 'var(--size-36)',
					fontWeight: '800',
				},
			}),
		],
		'PaywallNowGoalMetrics',
	)

	return mergeDeep(
		{ ...schema },
		{
			order,
			components: {
				PaywallNowGoalMetrics: (): PaywallComponentProps.NowGoalMetrics => ({
					currentLabel: 'Now',
					goalLabel: 'Goal',
					currentImage: beforePng,
					goalImage: afterPng,
					currentAccent: '#f25570',
					metrics: [
						{ label: 'Vitality', current: 2, goal: 5 },
						{ label: 'Energy', current: 1, goal: 5 },
					],
					note: 'This is not a guarantee or promise of results.',
				}),
			},
		},
	)
}
